"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var Iris = require("iris");
// set outgoing select to no flight (if no outgoing flights found, ...)
function handleOutgoingFlightsAfterFetch(store) {
    var outgoingAirports = store.getters['outgoingAirports'];
    if (outgoingAirports &&
        outgoingAirports.length === 1 &&
        outgoingAirports[0].code === 'NOFLIGHT' &&
        store.getters['outgoingFlightIsActivated']) {
        store.commit('SELECT_OUTGOING', 'NOFLIGHT');
    }
}
// query data from the backend API
function fetch(store, args) {
    return __awaiter(this, void 0, void 0, function () {
        var arrivalGermany, departureGermany, priceModel, preselect, preselectLowestPrice, roundtripsOnly, withNoFlight, withOutNoFlight, withRetNoFlight, key, json, _a, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    arrivalGermany = args.arrivalGermany;
                    departureGermany = args.departureGermany;
                    priceModel = args.flightOpts.priceModel;
                    preselect = args.preselect;
                    preselectLowestPrice = args.preselectLowestPrice;
                    roundtripsOnly = args.roundtripsOnly;
                    withNoFlight = args.withNoFlight;
                    withOutNoFlight = args.withOutNoFlight;
                    withRetNoFlight = args.withRetNoFlight;
                    delete args.preselect;
                    delete args.preselectLowestPrice;
                    delete args.roundtripsOnly;
                    delete args.withNoFlight;
                    delete args.withOutNoFlight;
                    delete args.withRetNoFlight;
                    key = JSON.stringify(args);
                    store.commit('SET_LOADING', key);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    _a = mapFlightResponse;
                    return [4 /*yield*/, Iris.client.flights(args.cruiseId, args.flightOpts)];
                case 2:
                    json = _a.apply(void 0, [_b.sent(),
                        args.cruiseId]);
                    // ... and map it back ---
                    if (store.getters['lastFetchRequestKey'] === key) {
                        store.commit('SET_OUT_WITH_NOFLIGHT', withOutNoFlight);
                        store.commit('SET_RET_WITH_NOFLIGHT', withRetNoFlight);
                        store.commit('SET_ROUNDTRIPS_ONLY', roundtripsOnly);
                        store.commit('IMPORT', json.data);
                        store.dispatch('setFlightClassDefaults');
                        store.dispatch('revalidateSelectionOutgoing');
                        store.dispatch('revalidateSelectionReturning');
                        store.dispatch('handleOutgoingFlightsAfterFetch');
                        if (preselect) {
                            store.dispatch('preselect', { priceModel: priceModel, arrivalGermany: arrivalGermany, departureGermany: departureGermany });
                        }
                        if (preselectLowestPrice) {
                            store.dispatch('preselectLowestPriceFlight', { priceModel: priceModel, arrivalGermany: arrivalGermany, departureGermany: departureGermany });
                        }
                        store.dispatch('priceDifference');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    // TODO: retry?
                    console.log('ajax error on getAir: ', e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
// is the selected code still in the displayed list?
function revalidateSelectionOutgoing(store) {
    var list = store.getters['outgoingAirports'];
    var isEnabled = store.getters['outgoingFlightIsActivated'];
    if (list.length === 2 && isEnabled) {
        // store.commit('SELECT_OUTGOING', list[1].code)
    }
    else {
        var out_1 = store.getters['outgoingSelectionCode'];
        var valid = lodash_1.find(list, function (item) {
            return item.code === out_1;
        });
        if (out_1 && !valid) {
            store.commit('SELECT_OUTGOING', 'NOFLIGHT');
            store.commit('SET_RNF_DEPARTURE', false);
        }
        var ret_1 = store.getters['returningSelectionCode'];
        if (out_1 === '' && ret_1 !== 'NOFLIGHT' && ret_1 !== '') {
            valid = lodash_1.find(list, function (item) {
                return item.code === ret_1;
            });
            if (valid) {
                store.commit('SELECT_OUTGOING', ret_1);
            }
        }
    }
}
// is the selected code still in the displayed list?
function revalidateSelectionReturning(store) {
    var list = store.getters['returningAirports'];
    if (list.length === 1 && list[0].code === 'NOFLIGHT') {
        // store.dispatch('deactivateReturning')
        store.commit('SELECT_RETURNING', 'NOFLIGHT');
        store.commit('SET_RNF_ARRIVAL', false);
    }
    else {
        store.dispatch('autoSelectReturning');
    }
}
// defines which flight classes are available
function setFlightClassDefaults(store) {
    var itemOut = store.getters['outgoingFlightClass'];
    var listOut = store.getters['outgoingFlightClasses'];
    if (lodash_1.find(listOut, function (fc) {
        return fc.code === itemOut;
    })) {
        return;
    }
    else if (lodash_1.find(listOut, function (fc) {
        return fc.code === 'Y';
    })) {
        store.commit('SELECT_OUTGOING_FLIGHT_CLASS', 'Y');
    }
    else if (listOut && listOut.length > 0) {
        store.commit('SELECT_OUTGOING_FLIGHT_CLASS', listOut[0].code);
    }
}
// as the name suggests...
function setOutgoingFlightClass(store, _a) {
    var code = _a.code, priceModel = _a.priceModel, departureGermany = _a.departureGermany, arrivalGermany = _a.arrivalGermany;
    var listOut = store.getters['outgoingFlightClasses'];
    if (lodash_1.find(listOut, function (fc) {
        return fc.code === code;
    })) {
        var outSelection_1 = lodash_1.cloneDeep(store.getters['outgoingSelectionCode']);
        var retSelection_1 = lodash_1.cloneDeep(store.getters['returningSelectionCode']);
        store.commit('SELECT_OUTGOING_FLIGHT_CLASS', code);
        store.commit('SELECT_RETURNING_FLIGHT_CLASS', code);
        var outFlightCodes = store.getters['outgoingAirports'];
        var retFlightCodes = store.getters['returningAirports'];
        // re-select previous airport selection after flight class change if possible
        if (lodash_1.find(outFlightCodes, function (ofc) {
            return ofc.code === outSelection_1;
        })) {
            store.dispatch('selectOutgoing', {
                code: outSelection_1,
                priceModel: priceModel,
                departureGermany: departureGermany
            });
        }
        else {
            store.commit('SELECT_OUTGOING', '');
        }
        if (lodash_1.find(retFlightCodes, function (ofc) {
            return ofc.code === retSelection_1;
        })) {
            store.dispatch('selectReturning', {
                code: retSelection_1,
                priceModel: priceModel,
                arrivalGermany: arrivalGermany
            });
        }
        else {
            store.commit('SELECT_RETURNING', '');
        }
    }
}
// surprising function, does what it sounds like
function setReturningFlightClass(store, _a) {
    var code = _a.code, priceModel = _a.priceModel, departureGermany = _a.departureGermany, arrivalGermany = _a.arrivalGermany;
    setOutgoingFlightClass(store, { code: code, priceModel: priceModel, departureGermany: departureGermany, arrivalGermany: arrivalGermany });
}
// actually select one of the available flights
function selectOutgoing(store, _a) {
    var code = _a.code, priceModel = _a.priceModel, departureGermany = _a.departureGermany;
    var list = store.getters['outgoingAirports'];
    var valid = lodash_1.find(list, function (item) {
        return item.code === code;
    });
    if (valid) {
        store.commit('SELECT_OUTGOING', code);
        store.dispatch('revalidateSelectionReturning');
        store.dispatch('priceDiffer');
        store.dispatch('priceDifference');
        if (code === 'NOFLIGHT') {
            store.commit('SET_RNF_DEPARTURE', false);
        }
        else if (!store.getters['validForRnf']) {
            store.commit('SET_RNF_DEPARTURE', false);
        }
        else if (store.getters['validForRnf'] &&
            store.getters['rnfIncluded'](priceModel) && departureGermany) {
            store.commit('SET_RNF_DEPARTURE', true);
        }
    }
}
// actually select one of the available flights
function selectReturning(store, _a) {
    var code = _a.code, priceModel = _a.priceModel, arrivalGermany = _a.arrivalGermany;
    var list = store.getters['returningAirports'];
    var valid = lodash_1.find(list, function (item) {
        return item.code === code;
    });
    if (valid) {
        store.commit('SELECT_RETURNING', code);
        store.dispatch('revalidateSelectionOutgoing');
        store.dispatch('priceDiffer');
        store.dispatch('priceDifference');
        if (code === 'NOFLIGHT') {
            store.commit('SET_RNF_ARRIVAL', false);
        }
        else if (!store.getters['validForRnf']) {
            store.commit('SET_RNF_ARRIVAL', false);
        }
        else if (store.getters['validForRnf'] &&
            store.getters['rnfIncluded'](priceModel) && arrivalGermany) {
            store.commit('SET_RNF_ARRIVAL', true);
        }
    }
}
// auto-select the returning flight if only one is possible
function autoSelectReturning(store) {
    var list = store.getters['returningAirports'];
    var code = store.getters['returningSelectionCode'];
    var outCode = store.getters['outgoingSelectionCode'];
    var valid = lodash_1.find(list, function (item) {
        return item.code === code;
    });
    if (!valid && code !== '' && code !== 'NOFLIGHT') {
        if (outCode && outCode !== '' && outCode !== 'NOFLIGHT') {
            valid = lodash_1.find(list, function (item) {
                return item.code === outCode;
            });
            if (valid) {
                store.commit('SELECT_RETURNING', outCode);
                code = outCode;
            }
        }
        else {
            store.commit('SELECT_RETURNING', 'NOFLIGHT');
            code = 'NOFLIGHT';
        }
    }
    if (outCode !== '' && outCode !== 'NOFLIGHT') {
        if ((code === '' || code === 'NOFLIGHT') &&
            !store.getters['roundtripsOnly']) {
            var valid_1 = lodash_1.find(list, function (item) {
                return item.code === outCode;
            });
            if (valid_1 && (list.length === 1 || code === '')) {
                store.commit('SELECT_RETURNING', outCode);
            }
            else {
                if (!valid_1 && list.length === 1) {
                    store.commit('SELECT_RETURNING', list[0].code);
                }
            }
        }
        else if (code === '' || code === 'NOFLIGHT') {
            var valid_2 = lodash_1.find(list, function (item) {
                return item.code === outCode;
            });
            if (valid_2) {
                store.commit('SELECT_RETURNING', outCode);
            }
            else {
                store.commit('SELECT_RETURNING', list[0].code);
            }
        }
    }
}
// auto-select the outgoing flight if none selected and retCode = outCode
function autoSelectOutgoing(store) {
    var list = store.getters['outgoingAirports'];
    var isEnabled = store.getters['outgoingFlightIsActivated'];
    var code = store.getters['outgoingSelectionCode'];
    var valid = lodash_1.find(list, function (item) {
        return item.code === code;
    });
    if (!valid && code !== '') {
        store.commit('SELECT_OUTGOING', 'NOFLIGHT');
    }
    var retCode = store.getters['returningSelectionCode'];
    if (retCode !== '' && retCode !== 'NOFLIGHT' && code === '') {
        var valid_3 = lodash_1.find(list, function (item) {
            return item.code === retCode;
        });
        if (valid_3) {
            store.commit('SELECT_OUTGOING', retCode);
        }
    }
}
// apply a priceDiffer or resets if no value given
function priceDiffer(store, differ) {
    if (differ && differ !== 0) {
        store.commit('SET_PRICE_DIFFER', differ);
    }
    else {
        if (store.getters['priceDiffer'] !== 0) {
            store.commit('SET_PRICE_DIFFER', 0);
        }
    }
}
// select the first flight, preferring RT > OJ > O/R
function preselect(store, _a) {
    var priceModel = _a.priceModel, departureGermany = _a.departureGermany, arrivalGermany = _a.arrivalGermany;
    var listOut = store.getters['outgoingAirports'];
    if (listOut && listOut.length > 0) {
        var outIdx = listOut.length > 1 ? 1 : 0;
        store.dispatch('selectOutgoing', {
            code: listOut[outIdx].code,
            priceModel: priceModel,
            departureGermany: departureGermany
        });
    }
    var listRet = store.getters['returningAirports'];
    var outCode = store.getters['returningSelectionCode'];
    if ((!outCode || outCode === 'NOFLIGHT') && listRet && listRet.length > 0) {
        var retIdx = listOut.length > 1 ? 1 : 0;
        store.dispatch('selectReturning', {
            code: listRet[retIdx].code,
            priceModel: priceModel,
            arrivalGermany: arrivalGermany
        });
    }
}
// select the flight with the lowest price
function preselectLowestPriceFlight(store, _a) {
    var priceModel = _a.priceModel, arrivalGermany = _a.arrivalGermany, departureGermany = _a.departureGermany;
    var flight = store.getters['lowestPriceFlight'];
    if (flight) {
        if (flight.outgoing &&
            flight.outgoing.outgoingFlight &&
            flight.outgoing.outgoingFlight.segments &&
            flight.outgoing.outgoingFlight.segments.length > 0) {
            store.dispatch('selectOutgoing', {
                code: flight.outgoing.outgoingFlight.segments[0].departureAirportCode,
                priceModel: priceModel,
                departureGermany: departureGermany
            });
        }
        if (flight.returning &&
            flight.returning.returnFlight &&
            flight.returning.returnFlight.segments &&
            flight.returning.returnFlight.segments.length > 0) {
            var returnFlight = flight.returning.returnFlight.segments[flight.returning.returnFlight.segments.length - 1];
            store.dispatch('selectReturning', {
                code: returnFlight.arrivalAirportCode,
                priceModel: priceModel,
                arrivalGermany: arrivalGermany
            });
        }
    }
}
// caculate and set price difference
function priceDifference(store) {
    var difference = store.getters['currentPrice'] - store.getters['lowestPrice'];
    store.commit('SET_PRICE_DIFFERENCE', difference);
}
function resetStore(store) {
    store.commit('RESET_STATE');
}
exports.resetStore = resetStore;
function resetRnf(store) {
    store.commit('RESET_RNF_STATE');
}
exports.resetRnf = resetRnf;
function resetRnfPremium(store) {
    store.commit('RESET_RNF_STATE');
    if (store.getters['validDepartureRnf']) {
        store.commit('SET_RNF_DEPARTURE', true);
    }
    if (store.getters['validArrivalRnf']) {
        store.commit('SET_RNF_ARRIVAL', true);
    }
}
exports.resetRnfPremium = resetRnfPremium;
function mark(store) {
    store.commit('MARK_AS_TOUCHED');
}
exports.mark = mark;
function rnfTotalPrice(store) {
    store.commit('SET_RNF_TOTAL_PRICE');
}
exports.rnfTotalPrice = rnfTotalPrice;
// tslint:disable-next-line:cyclomatic-complexity
function setRnfDirection(store, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (data.direction === 'arrival') {
                store.commit('SET_RNF_ARRIVAL', data.value);
            }
            else if (data.direction === 'departure') {
                store.commit('SET_RNF_DEPARTURE', data.value);
            }
            return [2 /*return*/];
        });
    });
}
exports.setRnfDirection = setRnfDirection;
function findTransportations(store, data) {
    return __awaiter(this, void 0, void 0, function () {
        var result, direction, directions, _i, directions_1, explicitDirection, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = [];
                    direction = store.getters['rnfDirection'];
                    directions = (direction == 'OJ') ? ['O', 'R'] : [direction];
                    _i = 0, directions_1 = directions;
                    _a.label = 1;
                case 1:
                    if (!(_i < directions_1.length)) return [3 /*break*/, 4];
                    explicitDirection = directions_1[_i];
                    request = createRequest(store, data, explicitDirection);
                    return [4 /*yield*/, Iris.client.railTransport(request)];
                case 2:
                    response = _a.sent();
                    result.push.apply(result, mapToTransport(response));
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    store.commit('SET_TRANSPORTATION', result);
                    return [2 /*return*/];
            }
        });
    });
}
exports.findTransportations = findTransportations;
// export everything compliant to the vuex specification for actions
exports.default = {
    fetch: fetch,
    revalidateSelectionOutgoing: revalidateSelectionOutgoing,
    revalidateSelectionReturning: revalidateSelectionReturning,
    selectOutgoing: selectOutgoing,
    selectReturning: selectReturning,
    autoSelectReturning: autoSelectReturning,
    autoSelectOutgoing: autoSelectOutgoing,
    setFlightClassDefaults: setFlightClassDefaults,
    setOutgoingFlightClass: setOutgoingFlightClass,
    setReturningFlightClass: setReturningFlightClass,
    priceDiffer: priceDiffer,
    preselect: preselect,
    preselectLowestPriceFlight: preselectLowestPriceFlight,
    priceDifference: priceDifference,
    handleOutgoingFlightsAfterFetch: handleOutgoingFlightsAfterFetch,
    resetStore: resetStore,
    mark: mark,
    rnfTotalPrice: rnfTotalPrice,
    setRnfDirection: setRnfDirection,
    findTransportations: findTransportations,
    resetRnf: resetRnf,
    resetRnfPremium: resetRnfPremium
};
// maps iris flights call response to 'old' world for further procession
function mapFlightResponse(response, cruiseId) {
    // console.log('response', response)
    var mapped = {
        outgoing: [],
        returning: [],
        openjaw: [],
        roundtrip: [],
    };
    for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
        var flight = response_1[_i];
        var outgoingFlight = {
            segments: mapFlightConnections(lodash_1.filter(flight.connections, ['direction', 'O']), cruiseId),
            price: flight.direction === 'R' || flight.direction === 'O'
                ? flight.price
                : flight.price / 2,
        };
        var returningFlight = {
            segments: mapFlightConnections(lodash_1.filter(flight.connections, ['direction', 'R']), cruiseId),
            price: flight.direction === 'R' || flight.direction === 'O'
                ? flight.price
                : flight.price / 2,
        };
        var outgoingFlightCode = '';
        var returningFlightCode = '';
        if (flight.direction === 'O') {
            returningFlight = null;
            returningFlightCode = '';
            outgoingFlightCode = lodash_1.head(outgoingFlight.segments).departureAirportCode;
        }
        else if (flight.direction === 'R') {
            outgoingFlight = null;
            outgoingFlightCode = '';
            returningFlightCode = lodash_1.last(returningFlight.segments).arrivalAirportCode;
        }
        else {
            outgoingFlightCode = lodash_1.head(outgoingFlight.segments).departureAirportCode;
            returningFlightCode = lodash_1.last(returningFlight.segments).arrivalAirportCode;
        }
        var airConn = {
            code: flight.id,
            class: flight.class,
            className: flight.className,
            outgoingFlight: outgoingFlight,
            outgoingFlightCode: outgoingFlightCode,
            returnFlight: returningFlight,
            returnFlightCode: returningFlightCode,
            flightDirection: flight.direction,
        };
        switch (airConn.flightDirection) {
            case 'RT':
                mapped.roundtrip.push(airConn);
                break;
            case 'OJ':
                mapped.openjaw.push(airConn);
                break;
            case 'O':
                mapped.outgoing.push(airConn);
                break;
            case 'R':
                mapped.returning.push(airConn);
        }
    }
    // console.log('mapped', JSON.stringify(mapped))
    return { data: mapped };
}
function mapFlightConnections(flightConnections, cruiseId) {
    var mapped = [];
    for (var _i = 0, flightConnections_1 = flightConnections; _i < flightConnections_1.length; _i++) {
        var conn = flightConnections_1[_i];
        var arrDates = conn.arrival.time.split(' ');
        var depDates = conn.departure.time.split(' ');
        var airline = conn.airline ? conn.airline : undefined;
        var carrier = {
            code: conn.flightNumber &&
                conn.flightNumber !== 'NANA' &&
                airline &&
                airline.id
                ? airline.id
                : undefined,
            name: conn.flightNumber &&
                conn.flightNumber !== 'NANA' &&
                airline &&
                airline.name
                ? airline.name
                : undefined,
            number: conn.flightNumber && conn.flightNumber !== 'NANA'
                ? conn.flightNumber
                : undefined,
            logo: airline && airline.logo ? airline.logo : undefined,
        };
        var segment = {
            arrivalAirportCode: conn.arrival.airport.id
                ? conn.arrival.airport.id
                : defaultAirport(cruiseId).code,
            arrivalAirportName: conn.arrival.airport.name
                ? conn.arrival.airport.name
                : defaultAirport(cruiseId).name,
            arrivalDate: arrDates[0],
            arrivalTime: arrDates.length > 1
                ? arrDates[1].substring(0, arrDates[1].lastIndexOf(':'))
                : '00:00',
            carrier: carrier,
            class: conn.class,
            className: conn.className,
            departureAirportCode: conn.departure.airport.id
                ? conn.departure.airport.id
                : defaultAirport(cruiseId).code,
            departureAirportName: conn.departure.airport.name
                ? conn.departure.airport.name
                : defaultAirport(cruiseId).name,
            departureDate: depDates[0],
            departureTime: depDates.length > 1
                ? depDates[1].substring(0, depDates[1].lastIndexOf(':'))
                : '00:00',
        };
        mapped.push(segment);
    }
    return mapped;
}
function defaultAirport(cruiseId) {
    if (cruiseId.startsWith('J')) {
        return {
            code: 'JAT',
            name: 'JUST AIDA',
        };
    }
    return {
        code: 'AID',
        name: 'AIDA',
    };
}
// tslint:disable-next-line:cyclomatic-complexity
function createRequest(store, data, explicitDirectionTrain) {
    var request = {
        cruiseID: data.cruiseId,
        adults: data.adults,
        juveniles: data.juveniles,
        children: data.children,
        paxe: getPaxRailInfo(data),
        priceModel: data.priceModel,
        transClass: store.getters['rnfCategory'],
        direction: explicitDirectionTrain,
        gateway: getGateway(store, explicitDirectionTrain),
        transportationType: 'RNF'
    };
    return request;
}
function getGateway(store, direction) {
    switch (direction) {
        case 'R':
            return store.getters['returningSelectionCode'];
        case 'O':
        case 'RT':
            return store.getters['outgoingSelectionCode'];
    }
    return '';
}
// tslint:disable-next-line:cyclomatic-complexity
function getPaxRailInfo(data) {
    var paxInfos = [];
    if (data.birthday0) {
        paxInfos.push({
            birthday: data.birthday0,
        });
    }
    if (data.birthday1) {
        paxInfos.push({
            birthday: data.birthday1,
        });
    }
    if (data.birthday2) {
        paxInfos.push({
            birthday: data.birthday2,
        });
    }
    if (data.birthday3) {
        paxInfos.push({
            birthday: data.birthday3,
        });
    }
    if (data.birthday4) {
        paxInfos.push({
            birthday: data.birthday4,
        });
    }
    return paxInfos;
}
function mapToTransport(railTransports) {
    var transportations = [];
    for (var _i = 0, railTransports_1 = railTransports; _i < railTransports_1.length; _i++) {
        var railTransport = railTransports_1[_i];
        var pricings = {
            Pricing: [],
        };
        var referencePrice = 0;
        for (var _a = 0, _b = railTransport.pricings.Pricing; _a < _b.length; _a++) {
            var pricing = _b[_a];
            pricings.Pricing.push({
                amount: pricing.amount,
                currency: 'EUR',
            });
            referencePrice += parseFloat(pricing.amount);
        }
        transportations.push({
            code: railTransport.code,
            type: 'RNF',
            tariffType: railTransport.transportationSegments[0].tariff,
            direction: railTransport.direction,
            transportationClass: railTransport.transClass,
            pricings: pricings,
            referencePrice: referencePrice
        });
    }
    return transportations;
}
//# sourceMappingURL=actions.js.map